var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncement1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#31B867",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9017 19.8815L27.0314 24.1394C26.3487 24.4671 25.6192 24.5492 24.8757 24.3827C24.389 24.2736 24.1457 24.2191 23.9497 24.1968C21.5166 23.9189 20 25.8446 20 28.0591V29.2744C20 31.4889 21.5166 33.4146 23.9497 33.1367C24.1457 33.1143 24.389 33.0598 24.8757 32.9509C25.6192 32.7842 26.3487 32.8663 27.0314 33.1941L35.9017 37.4521C37.9379 38.4295 38.956 38.9182 40.0912 38.5373C41.2263 38.1563 41.6159 37.3389 42.3952 35.7041C44.5349 31.215 44.5349 26.1185 42.3952 21.6294C41.6159 19.9946 41.2263 19.1772 40.0912 18.7962C38.956 18.4153 37.9379 18.904 35.9017 19.8815Z",
    stroke: "#31B867",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2771 43.6945L29.2887 45.3333C24.8065 41.7785 25.3541 40.0833 25.3541 33.3333H26.8659C27.4794 37.1478 28.9265 38.9546 30.9233 40.2626C32.1533 41.0682 32.4069 42.7633 31.2771 43.6945Z",
    stroke: "#31B867",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32.6667V24.6667",
    stroke: "#31B867",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement1);
export default __webpack_public_path__ + "static/media/announcement1.2243c52cd159cdcbb8d28856d9561661.svg";
export { ForwardRef as ReactComponent };